import { ResponsiveBar } from '@nivo/bar';
import { formatCurrency } from 'utils/formatter';

const BarChart = ({
  data,
  keys,
  indexKey,
  groupMode,
  layout,
  margin,
  valueFormat,
  valueScale,
  axisBottom,
  axisBottomLegend,
}) => {
  return (
    <ResponsiveBar
      data={data}
      keys={keys || Object.keys(data[0])}
      indexBy={indexKey}
      margin={margin}
      innerPadding={3}
      groupMode={groupMode}
      layout={layout}
      valueScale={valueScale}
      indexScale={{ type: 'band', round: true }}
      colors={['#2684FF', '#2EB67D', '#F5A623']}
      colorBy='id'
      borderColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            1.6
          ]
        ]
      }}
      axisTop={null}      
      axisBottom={axisBottom && {      
        legend: axisBottomLegend
      }}
      axisLeft={{}}
      axisRight={null}
      enableLabel={false}
      enableTotals={true}
      valueFormat={ valueFormat ? (value) => formatCurrency(value, 'en-US', 'compact') : null}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            1.6
          ]
        ]
      }}
      theme={{
        axis: {
          ticks: {
            text: {
              fontSize: 12,         // <-- Change font size
              fontWeight: 400,      // <-- Make text bold
              fill: '#1A1A1A',      // Optional: change color
              textTransform: 'capitalize'
            },
          },
        },
      }}
      role='application'
    />
  )
}
export default BarChart;